import { CButton, CModalBody, CModalFooter, CModalHeader } from "@coreui/react";
import React from "react";
import { DisplayRichText } from "src/components";
import StyledModal from "src/components/BasicModal/BasicModal.style";
import styled from "styled-components";

const StyledHeader = styled(CModalHeader)`
  padding-right: 3rem !important;
  p {
    font-size: 20px !important;
  }
`;

const NextQuestionModal = ({ question, onClose }) => {
  //   console.log("question", question);

  if (!question) return null;

  return (
    <StyledModal show={!!question} onClose={onClose} centered>
      <StyledHeader closeButton>
        <DisplayRichText value={question.question} />
      </StyledHeader>
      <CModalBody>
        <p className="text-left">
          Current score: {question["final-score"]} pts
        </p>
        <p style={{ fontSize: "18px" }} className="text-left font-semibold">
          Next goal to achieve:
        </p>
        <DisplayRichText value={question.nextAnswerLabel} />
      </CModalBody>
      <CModalFooter>
        <CButton color="dark border" onClick={onClose} className="text-white">
          Close
        </CButton>
      </CModalFooter>
    </StyledModal>
  );
};

export default NextQuestionModal;
